import { ListInterviewInvitesStatusItem } from '@sara/api-client';
import { Command, CommandEmpty, CommandItem, CommandList } from '@sara/ui/components/command';
import { Checkbox } from '@sara/ui/components/checkbox';
import type { FilterEditorProps } from '../types';

const ALL_STATUSES: ListInterviewInvitesStatusItem[] = [
  'PENDING',
  'IN_PROGRESS',
  'COMPLETED',
  'PAUSED',
  'EXHAUSTED',
  'ERROR',
  'EXPIRED',
  'LIVE_INTERVIEW_REQUESTED',
];

export const STATUS_LABELS: Record<ListInterviewInvitesStatusItem, string> = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Completed',
  PAUSED: 'Paused',
  EXHAUSTED: 'Tries exhausted',
  ERROR: 'Error',
  EXPIRED: 'Expired',
  LIVE_INTERVIEW_REQUESTED: 'Live interview requested',
};

export function FacetedStatusEditor({ search, onChange }: FilterEditorProps) {
  const selected = search.status ?? [];

  function toggle(status: ListInterviewInvitesStatusItem) {
    const isActive = selected.includes(status);
    const next = isActive ? selected.filter((s) => s !== status) : [...selected, status];
    onChange({ status: next.length > 0 ? next : undefined });
  }

  return (
    <Command>
      <CommandList>
        <CommandEmpty>No statuses found.</CommandEmpty>
        {ALL_STATUSES.map((status) => (
          <CommandItem
            key={status}
            onSelect={() => toggle(status)}
            className="flex items-center gap-2 text-[13px]"
          >
            <Checkbox
              checked={selected.includes(status)}
              className="pointer-events-none"
              tabIndex={-1}
            />
            {STATUS_LABELS[status]}
          </CommandItem>
        ))}
      </CommandList>
    </Command>
  );
}
